import { getGrowthBook } from '../../../services/growthbook';
import FEATURES from '../../../constants/featureToggling';
import { PROJECTS } from '../../../constants/centrifugo';

const FEATURES_CENTRIFUGO_PROJECTS_MAP = {
  [FEATURES.ENABLE_INSUFFICIENT_FUNDS]: PROJECTS.PERSONAL,
};

export const centrifugoProjectsChecker = (): string[] => {
  const projects = [];
  const gb = getGrowthBook();
  for (const feature in FEATURES_CENTRIFUGO_PROJECTS_MAP) {
    if (gb.isOn(feature)) {
      projects.push(FEATURES_CENTRIFUGO_PROJECTS_MAP[feature]);
    }
  }
  return projects;
};
